import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import axios from "axios";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";

function Testimonials({ className }) {
  const [testimonials, setTestimonials] = useState([]);
  const [expandedTestimonials, setExpandedTestimonials] = useState({});

  useEffect(() => {
    axios
      .get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/testimonialssort")
      .then((response) => {
        setTestimonials(response.data);
      })
      .catch((error) => {
        console.error("Error fetching testimonials:", error);
      });
  }, []);

  const toggleTestimonial = (id) => {
    setExpandedTestimonials((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const shouldShowReadMore = (text) => {
    if (!text) return false;
    return text.length > 260;
  };

  return (
    <section className="simple-testimonial-section">
      <div className="tf-container">

        <div className="simple-testimonial-heading">
          <span>Customer Reviews</span>

          <h2>Hear from our satisfied customers!</h2>

          <p>
            Read real experiences and insights from those who have benefited from our services.
            Let their journey inspire yours!
            <br />
            <Link to="/feedbacks">See All Reviews</Link>
          </p>
        </div>

        <div className="testimonial-slider-wrap">
          <button className="testimonial-arrow testimonial-prev" type="button">
            ‹
          </button>

          <button className="testimonial-arrow testimonial-next" type="button">
            ›
          </button>

          <Swiper
            modules={[Navigation]}
            navigation={{
              prevEl: ".testimonial-prev",
              nextEl: ".testimonial-next",
            }}
            spaceBetween={22}
            slidesPerView={4}
            loop={testimonials.length > 4}
            className="simple-testimonial-slider"
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 18,
              },
              576: {
                slidesPerView: 1,
                spaceBetween: 18,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 22,
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 22,
              },
            }}
          >
            {testimonials.map((item, index) => {
              const key = item.Id || index;
              const isExpanded = expandedTestimonials[key];

              return (
                <SwiperSlide key={key}>
                  <div className={`simple-testimonial-card ${isExpanded ? "expanded" : ""}`}>
                    <div className="quote-mark">“</div>

                    <div className="testimonial-content">
                      <p className={isExpanded ? "text-expanded" : ""}>
                        {item.Descriptions}
                      </p>

                      {shouldShowReadMore(item.Descriptions) && (
                        <button
                          type="button"
                          className="testimonial-read-btn"
                          onClick={() => toggleTestimonial(key)}
                        >
                          {isExpanded ? "Show less" : "Read more"}
                        </button>
                      )}
                    </div>

                    <div className="testimonial-author">
                      <h6>{item.Named}</h6>
                      <span>{item.Jobtitle}</span>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>

      </div>

      <style>
        {`
          .simple-testimonial-section {
            padding: 55px 0;
            background: linear-gradient(180deg, #fffaf4 0%, #ffffff 100%);
            overflow: hidden;
          }

          .simple-testimonial-heading {
            text-align: center;
            max-width: 760px;
            margin: 0 auto 34px auto;
          }

          .simple-testimonial-heading span {
            display: inline-block;
            padding: 6px 14px;
            border-radius: 999px;
            background: #fff3df;
            color: #b56b00;
            font-size: 13px;
            font-weight: 700;
            margin-bottom: 12px;
          }

          .simple-testimonial-heading h2 {
            font-size: 30px;
            line-height: 1.25;
            color: #1f2933;
            margin-bottom: 10px;
          }

          .simple-testimonial-heading p {
            font-size: 15px;
            line-height: 1.7;
            color: #666;
            margin: 0;
          }

          .simple-testimonial-heading a {
            display: inline-block;
            color: #14a077;
            font-weight: 700;
            font-size: 14px;
            margin-top: 5px;
            text-decoration: none;
          }

          .simple-testimonial-heading a:hover {
            text-decoration: underline;
          }

          .testimonial-slider-wrap {
            position: relative;
            padding: 0 48px;
          }

          .simple-testimonial-slider {
            padding: 8px 2px 12px;
          }

          .simple-testimonial-slider .swiper-wrapper {
            align-items: stretch;
          }

          .simple-testimonial-slider .swiper-slide {
            height: auto;
            display: flex;
          }

          .simple-testimonial-card {
            position: relative;
            width: 100%;
            height: 320px;
            min-height: 320px;
            max-height: 320px;
            background: #ffffff;
            border: 1px solid #f1e7dc;
            border-radius: 20px;
            padding: 28px 22px 22px;
            box-shadow: 0 10px 28px rgba(0, 0, 0, 0.055);
            display: flex;
            flex-direction: column;
            overflow: hidden;
            transition: all 0.25s ease;
          }

          .simple-testimonial-card:hover {
            transform: translateY(-4px);
            box-shadow: 0 16px 34px rgba(0, 0, 0, 0.09);
          }

          .simple-testimonial-card.expanded {
            height: auto;
            max-height: none;
            min-height: 320px;
            overflow: visible;
          }

          .quote-mark {
            position: absolute;
            top: 8px;
            right: 18px;
            font-size: 58px;
            line-height: 1;
            color: rgba(20, 160, 119, 0.13);
            font-family: Georgia, serif;
            font-weight: 700;
          }

          .testimonial-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            min-height: 0;
          }

          .testimonial-content p {
            font-size: 14px;
            line-height: 1.65;
            color: #444;
            margin: 0 0 10px 0;
            padding-top: 10px;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .testimonial-content p.text-expanded {
            display: block;
            -webkit-line-clamp: unset;
            -webkit-box-orient: unset;
            overflow: visible;
          }

          .testimonial-read-btn {
            border: none;
            background: transparent;
            color: #14a077;
            font-size: 13px;
            font-weight: 700;
            padding: 0;
            margin: 2px 0 14px 0;
            cursor: pointer;
            text-decoration: underline;
            align-self: flex-start;
          }

          .testimonial-read-btn:hover {
            color: #0d8462;
          }

          .testimonial-author {
            border-top: 1px solid #f0e8df;
            padding-top: 14px;
            margin-top: auto;
            flex-shrink: 0;
          }

          .testimonial-author h6 {
            font-size: 16px;
            font-weight: 700;
            color: #1f2933;
            margin-bottom: 3px;
          }

          .testimonial-author span {
            font-size: 13px;
            color: #777;
            display: block;
          }

        .testimonial-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 38px;
  height: 38px;
  border-radius: 12%;
  border: 1px solid #e7d8c8;
  background: #ffffff;
  color: #14a077;
  font-size: 30px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 3px;
  z-index: 5;
  cursor: pointer;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.08);
  transition: all 0.2s ease;
}

          .testimonial-arrow:hover {
            background: #14a077;
            color: #ffffff;
            border-color: #14a077;
          }

          .testimonial-prev {
            left: 0;
          }

          .testimonial-next {
            right: 0;
          }

          @media (max-width: 991px) {
            .testimonial-slider-wrap {
              padding: 0 42px;
            }

            .simple-testimonial-card {
              height: 310px;
              min-height: 310px;
              max-height: 310px;
            }

            .simple-testimonial-card.expanded {
              max-height: none;
              min-height: 310px;
            }
          }

          @media (max-width: 767px) {
            .simple-testimonial-section {
              padding: 38px 0;
            }

            .simple-testimonial-heading h2 {
              font-size: 24px;
            }

            .simple-testimonial-heading p {
              font-size: 14px;
            }

            .testimonial-slider-wrap {
              padding: 0 34px;
            }

            .testimonial-arrow {
              width: 32px;
              height: 32px;
              font-size: 26px;
            }

            .simple-testimonial-card {
              height: 300px;
              min-height: 300px;
              max-height: 300px;
              padding: 24px 20px 20px;
            }

            .simple-testimonial-card.expanded {
              height: auto;
              max-height: none;
              min-height: 300px;
            }

            .testimonial-content p {
              -webkit-line-clamp: 6;
            }
          }
        `}
      </style>
    </section>
  );
}

export default Testimonials;